export const MILLISECONDS_PER_DAY = 86_400_000;
